const validator = {
  /**
   * Valida condicional
   * @param  {String} value [description]
   * @param  {Object} args  [description]
   * @return {Boolean}      Retorna se o campo é valido
   */
  validate (value, args) {
    return args[0]
  }
}

export default validator
